// src/Utils/CardSkeleton.js
export const CardSkeleton = () => {
    return (
        <div
            style={{
                border: '1px solid #eee',
                borderRadius: '10px',
                padding: '16px',
                marginBottom: '12px',
                background: '#fff',
                boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                width: '100%',
            }}
        >
            <div style={{ width: '60%', height: '14px', background: '#e3e3e3', borderRadius: '5px', marginBottom: '10px' }} />
            <div style={{ width: '80%', height: '12px', background: '#e3e3e3', borderRadius: '5px', marginBottom: '12px' }} />

            <div style={{ width: '40%', height: '12px', background: '#e3e3e3', borderRadius: '5px', marginBottom: '8px' }} />

            <div style={{ width: '70%', height: '12px', background: '#e3e3e3', borderRadius: '5px', marginBottom: '8px' }} />

            <div style={{ width: '50%', height: '12px', background: '#e3e3e3', borderRadius: '5px' }} />
        </div>
    );
};

export default CardSkeleton;
